import { Component, NgZone, OnInit } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Store } from "@ngxs/store";
import { RESET_ERROR_MESSAGE } from "src/app/store/exception/error.action";

@Component({
  imports: [MatDialogModule],
  selector: "app-message-prompt-modal",
  templateUrl: "./message-prompt-modal.component.html",
  styleUrls: ["./message-prompt-modal.component.scss"],
})
export class MessagePromptModalComponent implements OnInit {
  protected error: string;
  private message: string;
  private readonly info: string;

  constructor(
    private readonly store: Store,
    public readonly dialogRef: MatDialogRef<MessagePromptModalComponent>,
    private readonly ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    const errorDetail = this.store.selectSnapshot<any>(
      (state) => state.ErrorState.detail,
    );
    if (errorDetail != null) {
      this.error = errorDetail.error;
      this.message = errorDetail.message;
    }
  }

  protected close(): void {
    this.store.dispatch(new RESET_ERROR_MESSAGE());
    this.ngZone.run(() => {
      this.dialogRef.close(true);
    });
  }
}
